import ApiService from './ApiService';

class IndividualTraderService {
  async prepareIndividualAccOpening(payload) {
    try {
      const response = await ApiService.call(
        '/secured/prepare_individual_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async saveIndividualAccOpening(payload) {
    try {
      const response = await ApiService.call(
        '/secured/save_individual_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async submitIndividualAccOpening(payload) {
    try {
      const response = await ApiService.call(
        '/secured/submit_individual_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async approveIndividualAccOpening(payload) {
    try {
      const response = await ApiService.call(
        '/secured/approve_individual_account_opening',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getIndividualTrader(payload) {
    try {
      const response = await ApiService.call('/secured/get_individual_trader', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getIndividualTraderList(payload) {
    try {
      const response = await ApiService.call(
        '/secured/get_individual_trader_list',
        'POST',
        payload,
      );

      return {
        traderList: response.result.map(data => {
          return {
            applicationNo: data.applicationInfo.applicationNo,
            clientType: data.applicationInfo.clientType,
            tradingAccountNo: data.individualTrader.tradingAccountNo,
            primaryEmail: data.individualTrader.primaryEmail,
            firstName: data.individualProfile.firstName,
            lastName: data.individualProfile.lastName,
            middleName: data.individualProfile.middleName,
            nameOnIdentity: data.individualProfile.nameOnIdentity,
            identityValue: data.individualProfile.identityValue,
            identityType: data.individualProfile.identityType,
            traderId: data.individualTrader.traderId,
            stage: data.individualTrader.stage,
            approvedDate: data.approvedDate,
          };
        }),
        totalCount: response.totalCount,
        page: response.offset,
        size: response.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new IndividualTraderService();
